<ng-container *transloco="let t;">
    <div class="row px-1">
        <div class="col-xl-5 col-md-5 col-12 py-1 ps-25 border-bottom d-flex justify-content-start align-items-start">
            <div class="d-flex justify-content-start align-items-center">
                <span placement="auto" triggers="hover" class="me-50 pb-25">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="#6e6b7b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        <path d="M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        <path d="M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        <path d="M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        <path d="M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        <path d="M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    </svg>
                </span>
                <label *ngIf="!isEditMode" placement="auto" triggers="hover"
                    [ngbTooltip]="t('Custom box card tooltip text - (Contract control section) - Double click to edit')"
                    class="mt-25 label-text" (dblclick)="editCustomBoxName(i)">
                    @if(box.name === 'Custom Box'){
                    {{ t('Documenttype - contarct card layout - custom box label') }}
                    }
                    @else{
                    {{ box.name }}
                    }

                </label>
            </div>
            <div class="custom-box-input mt-0" *ngIf="isEditMode">
                <input type="text" #customBoxInput class="form-control form-control-sm w-100 pb-0"
                    (blur)="renameCustomBox($event)" [value]="box.name">
            </div>
        </div>
        <div class="col-xl-5 col-md-5 col-12 py-1 p-0 border-bottom">
            <div class="form-group mb-0">
                <ng-select [items]="metaDataItems" [ngModel]="(box?.fields ?? []) | extractSelectedFields"
                    [multiple]="true" bindLabel="meta_data_name" bindValue="id" [virtualScroll]="false"
                    (add)="onAddingField($event)" (remove)="removeField($event)" [closeOnSelect]="false"
                    [searchable]="true"
                    [placeholder]="t('Field placeholder select document type - (General) - Select document field')">
                </ng-select>
            </div>
        </div>
        <div class="col-xl-2 col-md-2 pe-25 col-12 d-flex justify-content-end py-75 align-items-start border-bottom">
            <div class="">
                <span class="cursor-pointer me-1" placement="auto" container="body" [autoClose]="true" triggers="hover"
                    [ngbTooltip]="t('View (general) - View')" (click)="viewCustomBox(boxIndex)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none"
                        stroke="#6e6b7b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                    </svg>


                </span>
                <span class="cursor-pointer" placement="auto" container="body" [autoClose]="true" triggers="hover"
                    [ngbTooltip]="t('Delete (general) - Delete')" (click)="removeCustomBox.emit(boxIndex)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none"
                        stroke="#6e6b7b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
                        <path d="M9 9l6 6m0 -6l-6 6" />
                    </svg>
                </span>
            </div>

        </div>
    </div>
</ng-container>